import React from "react";
import {
  translationConstants,
  Directions,
  TableColumnStyle,
  paymentCardIcon,
  paymentConstants,
  paymentTypeConstants,
  paymentType,
  addonType,
  addonTypeConstants,
  timezoneConstants,
} from "../../../../constants";
import {
  copyToClipboard,
  formatDateTimeTOString,
  removeSpace,
  serverFormatToDateString,
} from "../../../../system";
import Tooltip from "@mui/material/Tooltip";

const getCardIcon = (cardType) => {
  // Find the icon based on the cardType
  return paymentCardIcon[cardType] || null; // Default to null if not found
};

export const getcolumns = (t, direction) => [
  {
    id: "id",
    accessor: "id",
    name: t(translationConstants.RECORD_ID),
    cell: (row) => (
      <Tooltip
        title={<div>{t(translationConstants.COPY_TO_CLIPBOARD)}</div>}
        placement="top"
        arrow
      >
        <div
          className="truncate-text cursor-pointer"
          onClick={() => copyToClipboard(row.id)}
        >
          {row.id}
        </div>
      </Tooltip>
    ),
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: TableColumnStyle.COLUMN_WIDTH_120,
    maxWidth: TableColumnStyle.COLUMN_WIDTH_120,
  },
  {
    id: "timestamp",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "timestamp",
    name: t(translationConstants.TIMESTAMP),
    selector: (row) =>
      serverFormatToDateString(
        row.timestampString,
        timezoneConstants.dateTimeFormatForTimeStamp
      ),
    minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "username",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "username",
    name: t(translationConstants.USERNAME),
    selector: (row) =>
      direction === Directions.rtl && removeSpace(row.arabicUsername)
        ? row.arabicUsername
        : row.username,
    minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "email",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "email",
    name: t(translationConstants.Email),
    selector: (row) => row.email,
    minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "cardType",
    center: true,
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "cardType",
    name: t(translationConstants.CARD_TYPE),
    selector: (row) => row.cardType,
    minWidth: TableColumnStyle.COLUMN_WIDTH_140,
    maxWidth: TableColumnStyle.COLUMN_WIDTH_140,
    cell: (row) => {
      // Get the icon for the current row's cardType
      const icon = getCardIcon(row.cardType);
      // Render the icon or a placeholder if icon is not found
      return (
        <div>
          {icon ? (
            <img
              className="payment-card-type-icon"
              src={icon}
              alt={row.cardType}
            />
          ) : (
            t(translationConstants.UNKNOWN)
          )}
        </div>
      );
    },
  },
  {
    id: "cardNumber",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "cardNumber",
    name: t(translationConstants.CARD_NUMBER),
    selector: (row) => paymentConstants.CARD_NUMBER_MASK + row.cardNumber,
    minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "paymentType",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "paymentType",
    name: t(translationConstants.PAYMENT_TYPE),
    selector: (row) =>
      t(
        translationConstants[
          paymentTypeConstants[row.paymentType] ||
            addonTypeConstants[row.addonType]
        ]
      ),
    minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "amount",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "amount",
    name: t(translationConstants.AMOUNT),
    selector: (row) => row.amount,
    minWidth: TableColumnStyle.COLUMN_WIDTH_120,
  },
  {
    id: "refund",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "refund",
    name: t(translationConstants.REFUND),
    selector: (row) => (row.refund ? row.refund : "-"),
    minWidth: TableColumnStyle.COLUMN_WIDTH_120,
  },
];

export const getPaymentStatusOptions = (t) => {
  return [
    {
      id: 2,
      value: paymentType.Membership,
      label: t(translationConstants.SSF_MEMBER_SHIP),
    },
    {
      id: 3,
      value: paymentType.Event,
      label: t(translationConstants.SSF_PAYMENT_EVENT_REGISTRATION),
    },
    {
      id: 4,
      value: paymentType.Competition,
      label: t(translationConstants.SSF_PAYMENT_COMPETITION_REGISTRATION),
    },
    {
      id: 5,
      value: paymentType.Center,
      label: t(translationConstants.SSF_PAYMENT_CENTER),
    },
    {
      id: 6,
      value: paymentType.Freelance,
      label: t(translationConstants.SSF_PAYMENT_FREELANCE),
    },
    {
      id: 7,
      value: paymentType.Addon,
      label: t(translationConstants.SSF_PAYMENT_ADDON),
    },
  ];
};

export const getAddonTypeOptions = (t) => {
  return [
    {
      id: 2,
      value: addonType.CenterSpot,
      label: t(translationConstants.SSF_PAYMENT_CENTER_SPOT_ADDON),
    },
    {
      id: 3,
      value: addonType.CenterSpotSport,
      label: t(translationConstants.SSF_PAYMENT_CENTER_SPOT_SPORT_ADDON),
    },
    {
      id: 4,
      value: addonType.FreelanceSport,
      label: t(translationConstants.SSF_PAYMENT_FREELANCE_SPORT_ADDON),
    },
  ];
};
